// bm-design-system: CopyField — monospace value display with copy-to-clipboard
import * as React from "react"
import { Check, Copy } from "lucide-react"
import { cn } from "@/lib/utils"

export function CopyField({
  value,
  className,
  ariaLabel = "Copy to clipboard",
}: {
  value: string
  className?: string
  ariaLabel?: string
}) {
  const [copied, setCopied] = React.useState(false)

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value)
      setCopied(true)
      window.setTimeout(() => setCopied(false), 2000)
    } catch {
      // clipboard unavailable — leave the value selectable
    }
  }

  return (
    <div
      className={cn(
        "flex items-center gap-2 rounded-lg border border-hairline bg-page px-3 py-2",
        className,
      )}
    >
      <code className="min-w-0 flex-1 overflow-x-auto font-mono text-xs whitespace-nowrap text-ink-body">
        {value}
      </code>
      <button
        type="button"
        onClick={copy}
        aria-label={ariaLabel}
        className="shrink-0 rounded-md p-1.5 text-ink-muted transition-colors hover:bg-surface hover:text-ink-display"
      >
        {copied ? <Check className="size-4 text-accent" /> : <Copy className="size-4" />}
      </button>
    </div>
  )
}
